module.exports = __webpack_public_path__ + "img/unlock-wallet.3f0ec389.png";